// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__Vedj0","author":"Table_author__pHadK","authorImage":"Table_authorImage__VsavY","unreadRow":"Table_unreadRow__3SH3V"};